import styled, { css } from 'styled-components';

export const StepContainer = styled.div`
  cursor: pointer;
  border-radius: 8px;
  padding: 3px 10px;
  margin-right: 10px;
  font-size: 13px;
  background-color: ${(props) => props.theme.colors.background.primary};
  border: 1px solid ${(props) => props.theme.colors.divider.primary};
  color: ${(props) => props.theme.colors.element.secondary};
  ${(props) =>
    props.done &&
    css`
      border: 1px solid ${(props) => props.theme.colors.positive.primary}
      color: ${(props) => props.theme.colors.positive.primary}
      background-color: ${(props) => props.theme.colors.positive.secondary}
  `};

  ${(props) =>
    props.active &&
    css`
      border: 1px solid ${(props) => props.theme.colors.brand.primary}
      color: ${(props) => props.theme.colors.brand.primary}
      background-color: ${(props) => props.theme.colors.brand.secondary}
    `};

  &:active {
    opacity: 0.5;
  }
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow-x: auto;
`;
